// SLMSidebar.tsx
import React from "react";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

interface SLMSidebarProps {
    recording: boolean;
    onStartStop: () => void;
    onSaveData: () => void;
    onUpdateChartSettings: (newSettings: any) => void;
    onResetMaxLevels: () => void;
    onUpdateReferenceCurve: (curve: number[] | null) => void;
}

const hardcodedReferenceCurve = [
    70, 70, 70, 77, 79, 88, 76, 86, 87,
    73, 85, 81, 85, 85, 82, 89, 86, 87,
    85, 88, 85, 85, 88, 88, 88, 89, 87
];

const SLMSidebar: React.FC<SLMSidebarProps> = ({
                                                   recording,
                                                   onStartStop,
                                                   onSaveData,
                                                   onUpdateChartSettings,
                                                   onResetMaxLevels,
                                                   onUpdateReferenceCurve,
                                               }) => {
    return (
        <MDBox sx={{ width: '240px', padding: '16px', borderLeft: '1px solid #ddd' }}>
            <MDButton variant="contained" onClick={onStartStop}>
                {recording ? "Stop Recording" : "Start Recording"}
            </MDButton>
            <MDBox mt={2}>
                <MDButton variant="outlined" color="secondary" onClick={onSaveData}>
                    Save Data
                </MDButton>
            </MDBox>
            <MDBox mt={2}>
                <MDButton variant="outlined" color="secondary" onClick={onResetMaxLevels}>
                    Reset Max Levels
                </MDButton>
            </MDBox>
            {/* Button to set the reference curve */}
            <MDBox mt={2}>
                <MDButton variant="outlined" color="secondary" onClick={() => onUpdateReferenceCurve(hardcodedReferenceCurve)}>
                    Set Reference Curve
                </MDButton>
            </MDBox>
            {/* Button to clear the reference curve */}
            <MDBox mt={2}>
                <MDButton variant="outlined" color="secondary" onClick={() => onUpdateReferenceCurve(null)}>
                    Clear Reference Curve
                </MDButton>
            </MDBox>
        </MDBox>
    );
};

export default SLMSidebar;
